"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkPermission = exports.checkRole = void 0;
const checkList = (list, str) => {
    if (!list) {
        return false;
    }
    if (typeof list === 'string') {
        return list === str;
    }
    if ('some' in list) {
        return list.some((v) => v === str);
    }
    return false;
};
/**
 * @deprecated Role checks should be converted into new permissions.
 * @example
 * // e.g. checkRole(userRoles, roleTypes.SUPER_ADMIN) on a page or API to edit users should become:
 * // Frontend:
 * usePermissionCheck({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * });
 * // OR
 * const MyComponent = (props) => <div {...props} />;
 * const withPermission = HasPermission({
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 *
 * // Backend:
 * const hasPermission = await authorization.requesterHasPermission(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 * // OR
 * await authorization.validateRequesterPermissions(requester, {
 *   action: PermissionAction.Edit,
 *   resourceType: PermisionResourceType.User,
 *   resource: PermissionResourceAlias.All
 * }, []);
 */
const checkRole = (userRoles, role) => checkList(userRoles, role);
exports.checkRole = checkRole;
/**
 * @deprecated Use usePermissionCheck() react hook or HasPermission() HOC in the frontend, or ctx.authorization.requesterHasPermission in the backend.
 * @example
 * // Permission Checks should be migrated to the new functions:
 * // Use usePermissionCheck() react hook or HasPermission() HOC in the frontend, or ctx.authorization.requesterHasPermission in the backend.
 * // e.g. checkPermission(loginUser.permissions, permissionTypes.GRADE_VIEW_OWN) or authorization.requesterHasLegacyPermissions(requester, [permissionTypes.GRADE_VIEW_OWN]) should become:
 * // Frontend:
 * const { isPermitted, loading } = usePermissionCheck({
 *   action: PermissionAction.View,
 *   resourceType: PermisionResourceType.Grade,
 *   resource: PermissionResourceAlias.Own
 * }, []);
 * // OR
 * const MyComponent = (props) => <div {...props} />;
 * const withPermission = HasPermission({
 *   action: PermissionAction.View,
 *   resourceType: PermisionResourceType.Grade,
 *   resource: PermissionResourceAlias.Own
 * }, []);
 * export default withPermission(MyComponent);
 *
 * // Backend:
 * const hasPermission = await authorization.requesterHasPermission(requester, {
 *   action: PermissionAction.View,
 *   resourceType: PermisionResourceType.Grade,
 *   resource: PermissionResourceAlias.Own
 * }, []);
 * // OR
 * await authorization.validateRequesterPermissions(requester, {
 *   action: PermissionAction.View,
 *   resourceType: PermisionResourceType.Grade,
 *   resource: PermissionResourceAlias.Own
 * }, []);
 */
const checkPermission = (userPermissions, permission) => checkList(userPermissions, permission);
exports.checkPermission = checkPermission;
//# sourceMappingURL=acl.js.map